import React from 'react'
import {
  TruncateAndTooltip,
  SpacingVertical,
  SPACING_40,
  SPACING_8,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_ITALIC_LIGHT,
  TEXT_VARIANT_LIGHT,
  Divider,
  Grid,
  GRID_VARIANT_COLLAPSED,
  GridCell,
  Flex
} from 'mailup-web-components'
import PropTypes from 'prop-types'

const SegmentationPanel = ({ title, items }) => {
  return (
    <>
      <Text variant={TEXT_VARIANT_BOLD}>{title}</Text>
      <SpacingVertical variant={SPACING_8} />
      <Divider />
      <Divider />
      <Grid cols={2} variant={GRID_VARIANT_COLLAPSED}>
        {items.map((item, index) => (
          <>
            <GridCell
              span={
                items.length % 2 !== 0 && items.length - 1 === index ? 2 : 1
              }
              key={`segmentation-item-${item.id}`}
            >
              <Flex padding='24px 16px 24px 0' justifyContent='flex-start'>
                <Text
                  variant={
                    item.deleted
                      ? TEXT_VARIANT_LIGHT
                      : TEXT_VARIANT_ITALIC_LIGHT
                  }
                >
                  <TruncateAndTooltip text={item.name} />
                </Text>
              </Flex>
              <Divider />
            </GridCell>
          </>
        ))}
      </Grid>
      <Divider />
      <SpacingVertical variant={SPACING_40} />
    </>
  )
}

export default SegmentationPanel

SegmentationPanel.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array
}
